import { useEffect, useRef, useState } from "react";

/*
  Die Eingabezeile über dem Blatt.

  ---------------------------------------------------------------
  Warum es sie gibt — und warum sie hier wichtiger ist als in Excel
  ---------------------------------------------------------------

  Das iPad ist der Hauptfall dieses Projekts. Sobald jemand eine Zelle
  öffnet, klappt die Bildschirmtastatur hoch und verdeckt die untere Hälfte
  des Bildschirms. Wer in Zeile 30 direkt in der Zelle tippt, sieht nicht,
  was er schreibt — und merkt einen Vertipper erst, wenn er die Tastatur
  wieder wegschiebt.

  Die Eingabezeile steht immer an derselben Stelle, oben, außerhalb des
  Blattes. Sie ist damit keine Zierde aus dem Excel-Vorbild, sondern die
  Antwort auf das Hauptgerät.

  Links steht der Bezug — `C7` —, damit man weiß, wohin man schreibt. Bei
  einer Formel ist das die einzige Stelle, an der man den geschriebenen Text
  sieht: In der Zelle steht das Ergebnis.
*/

export default function Eingabezeile({ bezug, wert, aus, aufAendern, aufFertig, aufAbbruch }) {
  const [text, setzeText] = useState(wert ?? "");
  const feldRef = useRef(null);

  /*
    Wechselt die gewählte Zelle, kommt ihr Inhalt ins Feld — aber nur dann.
    Ohne diese Bedingung würde jeder Tastendruck vom Blatt zurückgeschrieben
    und die Schreibmarke spränge ans Ende.
  */
  useEffect(() => {
    setzeText(wert ?? "");
  }, [bezug, wert]);

  function beiTaste(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      aufFertig(text, e.shiftKey ? "hoch" : "runter");
      return;
    }
    if (e.key === "Escape") {
      e.preventDefault();
      setzeText(wert ?? "");
      if (feldRef.current) feldRef.current.blur();
      aufAbbruch();
      return;
    }
    /*
      Die Pfeiltasten gehören hier dem Text, nicht dem Blatt. Wer in einer
      langen Formel etwas ausbessern will, muss sich darin bewegen können —
      deshalb wird das Ereignis hier angehalten, bevor es das Raster
      erreicht.
    */
    e.stopPropagation();
  }

  return (
    <div className="eingabezeile nicht-drucken">
      <span className="eingabezeile__bezug" aria-hidden="true">
        {bezug || "—"}
      </span>

      <label className="eingabezeile__feld">
        <span className="nur-fuer-vorleser">
          Inhalt der Zelle {bezug || "— keine Zelle gewählt"}
        </span>
        <input
          ref={feldRef}
          type="text"
          value={text}
          disabled={aus}
          placeholder={aus ? "" : "Zahl, Text oder Formel — Formeln beginnen mit ="}
          onChange={(e) => {
            setzeText(e.target.value);
            if (aufAendern) aufAendern(e.target.value);
          }}
          onKeyDown={beiTaste}
          onBlur={() => aufFertig(text, "bleiben")}
        />
      </label>
    </div>
  );
}
